import React from "react";
import { motion } from "framer-motion";
import { useTheme, Box, Typography, Container } from "@mui/material";

function FloatingPaths({ position }) {
    const paths = Array.from({ length: 36 }, (_, i) => ({
        id: i,
        d: `M-${380 - i * 5 * position} -${189 + i * 6}C-${
            380 - i * 5 * position
        } -${189 + i * 6} -${312 - i * 5 * position} ${216 - i * 6} ${
            152 - i * 5 * position
        } ${343 - i * 6}C${616 - i * 5 * position} ${470 - i * 6} ${
            684 - i * 5 * position
        } ${875 - i * 6} ${684 - i * 5 * position} ${875 - i * 6}`,
        color: `rgba(18,23,42,${0.1 + i * 0.03})`,
        width: 0.5 + i * 0.02,
    }));

    return (
        <Box sx={{ position: "absolute", inset: 0, pointerEvents: "none" }}>
            <svg width="100%" height="100%" viewBox="0 0 696 316" fill="none">
                <title>Background</title>
                {paths.map((path) => (
                    <motion.path
                        key={path.id}
                        d={path.d}
                        stroke="currentColor"
                        strokeWidth={path.width}
                        strokeOpacity={0.1 + path.id * 0.03}
                        initial={{ pathLength: 0.3, opacity: 0.6 }}
                        animate={{
                            pathLength: 1,
                            opacity: [0.3, 0.6, 0.3],
                            pathOffset: [0, 1, 0],
                        }}
                        transition={{
                            duration: 20 + Math.random() * 10,
                            repeat: Infinity,
                            ease: "linear",
                        }}
                    />
                ))}
            </svg>
        </Box>
    );
}

export default function Background({ title = "Welcome" }) {
    const theme = useTheme();       
    const backgroundDefault = theme.palette.background.default;

    const words = title.split(" ");


    return (
        <Box
            sx={{
                position: "relative",
                height: "100%",
                width: "100%",
                overflow: "hidden",
                bgcolor: {backgroundDefault},
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
            }}
        >
            <Box sx={{ position: "absolute", inset: 0 }}>
                <FloatingPaths position={1} />
                <FloatingPaths position={-1} />
            </Box>

            <Container
                sx={{
                    position: "relative",
                    zIndex: 10,
                    textAlign: "center",
                }}
            >
                <motion.div
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ duration: 2 }}
                >
                    <Typography
                        variant="h1"
                        sx={{
                            fontWeight: "bold",
                            fontSize: {
                                xs: "2rem",
                                sm: "2.5rem",
                                md: "3rem",
                            },
                            display: "flex",
                            flexWrap: "wrap",
                            justifyContent: "center",
                            gap: 1,
                        }}
                    >
                        {words.map((word, wordIndex) => (
                            <Box component="span" key={wordIndex}>
                                {word.split("").map((letter, letterIndex) => (
                                    <motion.span
                                        key={`${wordIndex}-${letterIndex}`}
                                        initial={{ y: 100, opacity: 0 }}
                                        animate={{ y: 0, opacity: 1 }}
                                        transition={{
                                            delay: wordIndex * 0.1 + letterIndex * 0.03,
                                            type: "spring",
                                            stiffness: 150,
                                            damping: 25,
                                        }}
                                    >
                                        {letter}
                                    </motion.span>
                                ))}
                            </Box>
                        ))}
                    </Typography>
                </motion.div>
            </Container>
        </Box>
    );
}
